<template>
  <div class="m-0 backgroundDiv">
    <div class="contentDiv">
      <van-row class="rowsDiv">
        <van-col span="3">
          <van-icon name="arrow-left" size="30" @click="rtList" color="#FFDA3E"/>
        </van-col>
        <van-col span="16"></van-col>
        <van-col span="3">
          <van-icon @click="onEditClick" v-if="visitData.createBy == loginUser.userId" size="30" color="#FFDA3E"
                    name="edit"/>
        </van-col>
      </van-row>
      <div class="rowsDiv">
        <van-row type="flex" justify="space-around" class="row-info">
          <van-col span="4">
            <div class="row-name">记录人</div>
          </van-col>
          <van-col span="16">
            <div class="row-value">{{ visitData.createByName }}</div>
          </van-col>
        </van-row>
        <van-row type="flex" justify="space-around" class="row-info">
          <van-col span="4">
            <div class="row-name">所属部门</div>
          </van-col>
          <van-col span="16">
            <div class="row-value">{{ visitData.createByDeptName }}</div>
          </van-col>
        </van-row>
        <van-row type="flex" justify="space-around" class="row-info">
          <van-col span="4">
            <div class="row-name">记录时间</div>
          </van-col>
          <van-col span="16">
            <div class="row-value">{{ moment(visitData.createTime).format('YYYY-MM-DD HH:mm') }}</div>
          </van-col>
        </van-row>
      </div>
      <div class="rowsDiv">
        <van-row type="flex" justify="space-around" class="row-info">
          <van-col span="4">
            <div class="row-name">所属客户</div>
          </van-col>
          <van-col span="16">
            <div class="row-value">{{ visitData.customerCompanyName }}</div>
          </van-col>
        </van-row>
        <van-row type="flex" justify="space-around" class="row-info">
          <van-col span="4">
            <div class="row-name">客户地址</div>
          </van-col>
          <van-col span="16">
            <div class="row-value">{{ visitData.customerCompanyPlace }}</div>
          </van-col>
        </van-row>
<!--        <van-row type="flex" justify="space-around" class="row-info">-->
<!--          <van-col span="4">-->
<!--            <div class="row-name">填报位置</div>-->
<!--          </van-col>-->
<!--          <van-col span="16">-->
<!--            <div class="row-value">{{ visitData.nowLocation }}</div>-->
<!--          </van-col>-->
<!--        </van-row>-->
        <van-row type="flex" justify="space-around" class="row-info">
          <van-col span="4">
            <div class="row-name">拜访日期</div>
          </van-col>
          <van-col span="16">
            <div class="row-value">{{ visitData.visitTime }}</div>
          </van-col>
        </van-row>
        <van-row type="flex" justify="space-around" class="row-info">
          <van-col span="4">
            <div class="row-name">拜访方式</div>
          </van-col>
          <van-col span="16">
            <div class="row-value">{{ visitData.visitTypeName }}</div>
          </van-col>
        </van-row>
        <van-row type="flex" justify="space-around" class="row-info">
          <van-col span="4">
            <div class="row-name">拜访人</div>
          </van-col>
          <van-col span="16">
            <div class="row-value">{{ visitData.customerUserName }}</div>
          </van-col>
        </van-row>
        <van-row type="flex" justify="space-around" class="row-info">
          <van-col span="4">
            <div class="row-name">拜访记录</div>
          </van-col>
          <van-col span="16">
            <div class="row-value">{{ visitData.visitGoal }}</div>
          </van-col>
        </van-row>
        <van-row type="flex" justify="space-around" class="row-info">
          <van-col span="4">
            <div class="row-name">联系电话</div>
          </van-col>
          <van-col span="16">
            <div class="row-value">{{ visitData.customerUserPhone }}</div>
          </van-col>
        </van-row>
        <van-row type="flex" justify="space-around" class="row-info">
           <van-field :value.prop="visitData.fileList" class="noAfterBorder fileValueBox" input-align="right" name="fj"  label="附件" placeholder="请上传文件">
          <template #input>
            <uploadFiles :disabled="true" :uploaderBtnShow="false"  moduleType="visit"  :files="visitData.fileList"></uploadFiles>
          </template>
        </van-field>
         <!--  <van-col span="16">
            <uploadFiles :disabled="true"  :files="visitData.fileList"></uploadFiles>
            图片预览 -->
            <!-- <div v-if="visitData.fileList.length > 0" style="display: flex;flex-wrap: wrap;">
                <van-image
                    v-for="(ite, ind) in imageFileList" :key="ind+1"
                    style="margin-top: 5px;margin-right: 5px;"
                    width="100"
                    height="100"
                    :src="ite.fileURL"
                    @click="viewImg(ite)"
                />
              <div class="text-left font-28 m-t-16 cor-4185EE" v-for="(item,index) in docFileList" :key="index" @click="viewImg(item)">{{ item.fileName || item.name }}</div>
            </div> 
          </van-col>-->
        </van-row>
      </div>
    </div>
  </div>
</template>
<script>
import {Row, Col, Cell, ImagePreview} from 'vant';
import {getCustomerVisitById} from '@/api/visit.js';
import moment from "moment/moment";
import uploadFiles from "@/components/uploadFiles/index.vue";
import mixin from "@/mixin/flow";
import * as ww from "@wecom/jssdk";

export default {
  components: {
    'van-row': Row,
    'van-col': Col,
    'van-cell': Cell,
    [ImagePreview.Component.name]: ImagePreview.Component,uploadFiles
  },
  mixins: [mixin],
  data() {
    return {
      id: '',
      // 拜访数据
      visitData: {
        fileList: []
      },
      // fileList: [],
      imageFileList: [],
      docFileList: [],
      loginUser: {},
    };
  },
  created() {
    setTimeout(() => {
      this.loginUser = JSON.parse(sessionStorage.getItem('userInfo'));
    }, 300);
    this.id = this.$route.query.id
    this.getClientDetails()
  },
  methods: {
    moment,
    rtList() {
      this.$router.go(-1)
      // this.$router.go(-1)
    },
    viewImg(item) {
      if (this.imageTypeList.includes(item.fileType)) {
        ImagePreview({
          images: this.imageFileList.map(item => item.fileURL),
          closeable: true
        });
      } else {
        if (this.$store.state.user.environmentType === 1) {
          this.registerWw().then(() => {
            console.log('registerWw completed, calling filePreview');
            ww.previewFile({
              url: item.previewUrl, // 需要预览文件的地址(必填，可以使用相对路径)
              name: item.name, // 需要预览文件的文件名，必须有带文件格式的后缀，例如.doc(不填的话取url的最后部分，最后部分是个包含格式后缀的文件名)
              size: item.fileSize,// 需要预览文件的字节大小(必填，而且大小必须正确，否则会打开失败)
            });
          }).catch((error) => {
            console.error('registerWw failed:', error);
            // 即使注册失败也尝试预览文件
            ww.previewFile({
              url: item.previewUrl, // 需要预览文件的地址(必填，可以使用相对路径)
              name: item.name, // 需要预览文件的文件名，必须有带文件格式的后缀，例如.doc(不填的话取url的最后部分，最后部分是个包含格式后缀的文件名)
              size: item.fileSize,// 需要预览文件的字节大小(必填，而且大小必须正确，否则会打开失败)
            });
          });
        } else {
          this.wwRegister(window.encodeURIComponent(location.href.split('#')[0]), ww => {
            ww.previewFile({
              url: item.previewUrl, // 需要预览文件的地址(必填，可以使用相对路径)
              name: item?.name,
              size: item.fileSize,
              success: function (res) {
                console.log('成功打开附件API', res)
              },
              fail: function (res) {
                console.log('打开附件API失败', res)
                // 在这里处理失败的情况，例如提示用户或进行其他操作
              }
            })
          })
        }
      }
    },
    onEditClick() {
      this.$router.push({path: '/visitAdd', query: {id: this.id}})
    },
    /**
     *  查询客户拜访记录详情
     */
    getClientDetails() {
      getCustomerVisitById(this.id).then(res => {
        if (res.code == '200') {
          this.visitData = res.data;
          // this.fileList = [];
          // res.data.fileList.forEach(item => {
          //   this.fileList.push(this.$store.state.settings.image_base_url + item.filePath)
          //   // this.fileList.push('http://192.169.1.94:8089/profile' + item.filePath)
          // })
          this.imageFileList = []
          this.docFileList = []
          res.data.fileList.forEach(item => {
            if (this.imageTypeList.includes(item.fileType)) {
              this.imageFileList.push({
                ...item,
                url: item.fileURL ? item.fileURL : item.previewUrl,
              })
            } else if (this.documentTypeList.includes(item.fileType)) {
              this.docFileList.push({
                ...item,
                url: item.fileURL ? item.fileURL : item.previewUrl,
              })
            }
          })
        }
      })
    },
  }
};
</script>
<style scoped>


.row-info {
  margin-bottom: 16px;
  margin-top: 20px;
}

.row-name {
  font-size: 28px;
  color: #969799;
}

.row-value {
  text-align: left;
  font-size: 28px;
  color: #000000;
}

.feedback-title {
  font-size: 35px;
  font-weight: 550;
  background-color: rgba(225, 218, 62, 1);
}

.backgroundDiv {
  background-color: rgb(247, 247, 247);
}

.contentDiv {
  margin: 4px 8px 0px 8px;
  border-radius: 20px;
  background-color: rgb(247, 247, 247);
  display: block;
}

.rowsDiv {
  margin: 4px 4px 0px 4px;
  padding: 2px 0px 2px 0px;
  border-radius: 20px;
  background-color: rgb(255, 255, 255);
  display: block;
}

</style>
